import {createMultiPathSVG} from './TEMPLATE'

// phosphor: copy
export const SquareBehindSquare4_Stroke2_Corner0_Rounded = createMultiPathSVG({
  paths: [
    'M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z',
  ],
  viewBox: '0 0 256 256',
})

// phosphor: copy
export const SquareBehindSquare_Stroke2_Corner2_Rounded = createMultiPathSVG({
  paths: [
    'M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z',
  ],
  viewBox: '0 0 256 256',
})
